import { jsx } from "react/jsx-runtime";
import { cn } from "../utils.js";
import { SearchInputVariant } from "./variants/search-input-variant.js";
import * as __rspack_external_react from "react";
const Input = /*#__PURE__*/ __rspack_external_react.forwardRef(({ variant, className, size = 'sm', ...props }, ref)=>{
    if ('search' === variant) {
        const defaultHeightClass = 'sm' === size ? 'tw-h-4' : 'tw-h-5.6';
        const hasHeightClass = className ? className.split(' ').some((cls)=>cls.includes('tw-h')) : false;
        return /*#__PURE__*/ jsx(SearchInputVariant, {
            ref: ref,
            className: cn('tw-input', !hasHeightClass && defaultHeightClass, 'sm' === size ? 'tw-font-body4' : 'tw-font-body3 tw-text-1.6', className),
            ...props
        });
    }
    return /*#__PURE__*/ jsx("div", {
        className: "tw-relative tw-flex tw-items-center",
        children: /*#__PURE__*/ jsx("input", {
            ref: ref,
            className: cn('tw-input', 'sm' === size ? 'tw-h-4 tw-font-body4' : 'tw-h-5.6 tw-font-body3 tw-text-1.6', className),
            ...props
        })
    });
});
Input.displayName = 'Input';
export { Input };
